
<div class="media-pipe-widget" :tabindex="tabindex" @click="handleClick($event)">
	<div class="media-pipe-widget-header flex-gap-8">
		<slot name="header" />
	</div>
	<div class="media-pipe-widget-stats">
		<slot name="stats" />
	</div>
	<div class="media-pipe-widget-content">
		<slot />
	</div>
	<div class="media-pipe-widget-footer">
		<slot name="footer" />
	</div>
</div>
